import { render, staticRenderFns } from "./System.vue?vue&type=template&id=807cb6ae&scoped=true&"
import script from "./System.vue?vue&type=script&lang=js&"
export * from "./System.vue?vue&type=script&lang=js&"
import style0 from "./System.vue?vue&type=style&index=0&id=807cb6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807cb6ae",
  null
  
)

export default component.exports